import React from 'react';

import  SolarPanels2025  from 'views/SolarPanels2025';


const DesktopAppPage = () => {
  return <SolarPanels2025/>;
};
export default DesktopAppPage;
